import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';
import { DataParser } from "../../../services";
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { map } from 'rxjs/internal/operators/map';

@Pipe({
  name: 'getCultureName'
})
export class GetCultureNamePipe implements PipeTransform {

  constructor(
    protected readonly translateService: TranslateService) {
  }

  transform(code: string, interpolateParams?: Object): Observable<string | object>  {

      if(!code) {
        return of(code);
      }
    return this.t(code.toUpperCase()).pipe(
        map(v => {
          if (!v || v.toString().includes('T.')) {
            v = code;
          }
          return v;
        })
      );


  }


  t(key?: string, interpolateParams?: Object): Observable<string | object> {
    if (!key) {
      return this.translateService.get('T', interpolateParams);
    }
    return this.translateService.get(`T.${key}`, interpolateParams);
  }

}
